import React, { ReactElement } from 'react'

import { Input } from 'antd'

import withCustomHandlers from 'components/formik/withCustomHandlers'

import { FormikWithCustomHandlersProps } from '../propTypes'

const { TextArea } = Input

interface FormikTextAreaProps<V> extends FormikWithCustomHandlersProps<V> {
    innerRef?: React.Ref<HTMLTextAreaElement>
}

const FormikTextArea = <
    V extends string | number | bigint | readonly string[] | undefined,
>({
    field: { value },
    form,
    handleChange,
    handleBlur,
    handleClick,
    innerRef,
    ...props
}: FormikTextAreaProps<V>): ReactElement => (
    <TextArea
        ref={innerRef}
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        onBlur={handleBlur}
        {...props}
    />
)

export default withCustomHandlers(FormikTextArea)
